import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'
import _imports_1 from '@/app/ui/assets/svg/attachment.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-6db8e6fc")

_pushScopeId("data-v-6db8e6fc")
const _hoisted_1 = { class: "py-4 mb-4 flex flex-row justify-start items-center border-b border-gray-lp-400" }
const _hoisted_2 = { class: "font-semibold text-20px mr-4 text-black-lp-200 capitalize" }
const _hoisted_3 = { class: "flex flex-row h-screen overflow-auto" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col mx-auto w-700px xxl:w-1100px"
}
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col mx-auto w-700px xxl:w-1100px"
}
const _hoisted_6 = {
  key: 2,
  class: "flex flex-col mx-auto w-700px xxl:w-1100px"
}
const _hoisted_7 = { class: "px-20 py-4" }
const _hoisted_8 = { class: "text-20px text-black-lp-200 font-semibold capitalize" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-row py-4 items-center"
}
const _hoisted_10 = { class: "w-8 mr-2" }
const _hoisted_11 = { class: "font-medium text-black-lp-200 text-12px xxl:text-14px whitespace-no-wrap mr-2" }
const _hoisted_12 = { class: "font-normal text-12px xxl:text-14px text-gray-lp-500 whitespace-no-wrap flex flex-row items-center" }
const _hoisted_13 = { class: "font-normal leading-loose text-gray-lp-300 text-12px xxl:text-14px mr-4 ql-editor" }
const _hoisted_14 = { class: "w-400px flex flex-row justify-between rounded-md text-12px xxl:text-14px py-4 px-4 items-center border border-gray-lp-400 my-8" }
const _hoisted_15 = { class: "flex flex-row items-start" }
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4 mr-3",
  alt: "attachment"
}, null, -1)
const _hoisted_17 = { class: "text-gray-lp-300" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_modal_show_image = _resolveComponent("modal-show-image")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("img", {
        src: _imports_0,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
        class: "w-5 mr-3 cursor-pointer",
        alt: "left"
      }),
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.detailData.title), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.$t("notification.loading")), 1))
        : _createCommentVNode("", true),
      (_ctx.isError && !_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_ErrorMessage, {
              errorType: _ctx.errorCause,
              onTryAgain: () => _ctx.getDetail(_ctx.id)
            }, null, 8, ["errorType", "onTryAgain"])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_6, [
            _withDirectives(_createVNode("img", {
              src: _ctx.detailData.bannerImage,
              class: "w-full h-48 cursor-pointer object-cover",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onOpenShowImage && _ctx.onOpenShowImage(...args))),
              alt: ""
            }, null, 8, ["src"]), [
              [_vShow, _ctx.detailData.bannerImage]
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, _toDisplayString(_ctx.detailData.title), 1),
              (!_ctx.isLoading)
                ? (_openBlock(), _createBlock("div", _hoisted_9, [
                    _createVNode("div", _hoisted_10, [
                      _createVNode("div", {
                        class: 
                `${_ctx.initialNameNotification.color} w-8 h-8 font-semibold text-12px items-center tracking-wider flex flex-col justify-center text-white rounded-full`
              
                      }, _toDisplayString(_ctx.initialNameNotification.initial), 3)
                    ]),
                    _createVNode("div", _hoisted_11, _toDisplayString(_ctx.detailData.createdBy), 1),
                    _createVNode("div", _hoisted_12, _toDisplayString(_ctx.formatDate(_ctx.detailData.releasedAt)), 1)
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode("div", _hoisted_13, null, 512), [
                [_directive_sanitize_html, _ctx.detailData.description]
              ]),
              _withDirectives(_createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode("div", _hoisted_17, _toDisplayString(_ctx.fileName(_ctx.detailData.attachment)), 1)
                ]),
                _createVNode("a", {
                  target: "_blank",
                  href: _ctx.detailData.attachment,
                  class: "text-red-lp-100 font-bold cursor-pointer"
                }, _toDisplayString(_ctx.$t("notification.download")), 9, ["href"])
              ], 512), [
                [_vShow, _ctx.detailData.attachment]
              ])
            ])
          ]))
    ]),
    _withDirectives(_createVNode(_component_modal_show_image, {
      onClose: _ctx.onCloseShowImage,
      image: _ctx.detailData.bannerImage
    }, null, 8, ["onClose", "image"]), [
      [_vShow, _ctx.isShow]
    ])
  ], 64))
})